const projects = [
    {
        "position": "Digital Forensics Investigation – Evidence Recovery and Reporting",
        "location": "Academic Security Project",
        "description": [
            "Used Autopsy to analyze a forensic disk image and recover deleted proprietary documents related to business operations and cryptographic methods.",
            "Documented findings, verified volume structure, and confirmed user intent through timeline analysis and file metadata.",
            "Created a formal incident report with supporting evidence and recommendations for further investigation."
        ],
        "skills": ["Digital Forensics", "Incident Response", "Evidence Handling", "Autopsy", "File System Analysis"],
        "time": ""
    },
    {
        "position": "Network Vulnerability Assessment – Wireshark and Nmap Analysis",
        "location": "Academic Security Project",
        "description": [
            "Conducted network mapping and vulnerability scanning to identify known CVEs including Windows Print Spooler RCE and SSH DoS flaws.",
            "Analyzed network traffic to detect TLS handshake failures, brute-force login attempts, and unauthorized port scans.",
            "Recommended mitigation strategies including TLS enforcement, firewall hardening, and MFA implementation."
        ],
        "skills": ["Network Security", "Vulnerability Assessment", "Wireshark", "Nmap", "CVE Analysis", "Firewall Hardening"],
        "time": ""
    },
    {
        "position": "Wireless and Mobile Security Evaluation – Risk Mitigation Plan",
        "location": "Academic Security Project",
        "description": [
            "Assessed vulnerabilities in a BYOD-enabled wireless network and mobile environment, identifying risks such as Evil Twin attacks and use of jailbroken devices.",
            "Proposed implementation of WPA3, 802.1X authentication, MDM/MAM solutions, and remote wipe protocols.",
            "Aligned recommendations with NIST SP 800-153 and mobile security best practices."
        ],
        "skills": ["Wireless Security", "Mobile Security", "BYOD", "NIST SP 800-153", "Risk Assessment", "MDM"],
        "time": ""
    },
    {
        "position": "Security System Evaluation and Remediation – Risk Assessment & Control Implementation",
        "location": "Academic Security Project",
        "description": ["Evaluated enterprise security assessment findings and identified critical gaps in authorization, endpoint protection, and network security controls.", "Designed remediation strategy implementing least-privilege access control, continuous monitoring, SIEM integration, and vulnerability risk response processes aligned with NIST SP 800-53 and FISMA guidance.", "Developed POA&M remediation tracking workflows to prioritize vulnerabilities and improve organizational risk visibility."],
        "skills": ["Risk Assessment", "Access Control", "SIEM Integration", "Continuous Monitoring", "NIST SP 800-53", "FISMA", "Vulnerability Management", "POA&M"],
        "time": ""
    },
    {
        "position": "Wireless and Mobile Security Evaluation – Risk Mitigation Plan",
        "location": "Academic Security Project",
        "description": [
            "Assessed vulnerabilities in a BYOD-enabled wireless and mobile environment, identifying risks such as Evil Twin attacks and jailbroken devices.",
            "Proposed implementation of WPA3, 802.1X authentication, MDM/MAM solutions, and remote wipe capabilities.",
            "Aligned recommendations with NIST SP 800-153 and mobile security best practices."
        ],
        "skills": ["Wireless Security", "Mobile Security", "BYOD", "NIST SP 800-153", "Risk Assessment", "MDM"],
        "time": ""
    },
    {
        "position": "Enterprise Network Security Architecture – Secure Network Merger Design",
        "location": "Academic Security Project",
        "description": [
            "Designed secure enterprise network architecture integrating DMZ isolation, VLAN segmentation, least-privilege access controls, and defense-in-depth principles.",
            "Identified high-risk vulnerabilities, including exposed services, insecure protocols, and excessive administrative privileges, recommending secure protocol migration (SFTP, SSH), MFA enforcement, and cloud-hosted service isolation.",
            "Developed compliance-aligned security design supporting HIPAA and GLBA regulatory requirements."
        ],
        "skills": ["Network Architecture", "Zero Trust", "VLAN Segmentation", "DMZ Design", "HIPAA Compliance", "GLBA Compliance", "Security Engineering"],
        "time": ""
    },
    {
        "position": "Stella Wine Guide",
        "link": "https://stellaburlingame.github.io/wine-guide/",
        "location": "Stella Alpina Osteria · Burlingame, CA, United States",
        "description": [
            "Designed and developed a React.js web application used by staff and management to centralize structured product data and operational reference information.",
            "Built dynamic filtering, data-display, and structured JSON-driven content modules to improve internal knowledge access and decision support.",
            "Delivered the system as a self-initiated digital transformation project that was adopted into operational workflows after leadership evaluation."
        ],
        "skills": ["React.js", "JavaScript", "UI/UX", "Data Modeling", "Digital Transformation"],
        "time": "Jun 2025 - Oct 2025"
    }
]
export default projects;